import React from 'react';
import WatchReview from '../watchReview'


function TheStrangers(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/VPeST2kxcg4" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all  things horror and foreign films. Over our next drink, we discuss home invasion film, 'The Strangers'. Conflicting thoughts on this one...."
            />
        )
    }   

export default TheStrangers;